import React, { useState } from "react";

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch("https://dgl-core-9x7.dailygolive.in/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("✅ Subscribed successfully!");
        setEmail("");
      } else {
        setMessage(data.message || "⚠️ Something went wrong.");
      }
    } catch (err) {
      setMessage("⚠️ Unable to connect. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-[#fafafa] py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-10">
        
        {/* Left */}
        <div className="max-w-lg">
          <p className="text-yellow-500 text-xs font-semibold uppercase tracking-widest mb-3">
            Newsletter
          </p>

          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
            Stay Updated with Daily Go
          </h2>

          <p className="text-gray-600 mt-3 text-sm leading-relaxed">
            Get exclusive deals, product updates, and business insights directly to your inbox.
          </p>
        </div>

        {/* Right */}
        <div className="w-full md:w-auto">
          <form 
            onSubmit={handleSubmit} 
            className="flex w-full sm:w-[420px] bg-white border border-gray-200 rounded-full shadow-sm overflow-hidden"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="flex-1 px-5 py-3 text-sm text-gray-800 focus:outline-none"
            />

            <button
              type="submit"
              disabled={loading}
              className="bg-yellow-500 px-6 py-3 text-sm font-semibold text-black hover:bg-yellow-400 transition disabled:opacity-50"
            >
              {loading ? "..." : "Subscribe"}
            </button>
          </form>

          {/* Message */}
          {message && (
            <p className="mt-3 text-sm text-gray-600">
              {message}
            </p>
          )}
        </div>

      </div>
    </section>
  );
};

export default NewsLetter;